import ControlBar from "./components/ControlBar";
import DemandCharts from "./components/DemandCharts";
import EventLog from "./components/EventLog";
import SimulationMap from "./components/SimulationMap";
import SimulationScene from "./components/SimulationScene";
import StationPanel from "./components/StationPanel";
import VehicleTable from "./components/VehicleTable";
import { useSimulation } from "./useSimulation";

export default function EvChargingSimPage() {
  const {
    simulation,
    speedMultiplier,
    stationDemandData,
    vehicleRows,
    currentTimeLabel,
    setSpeedMultiplier,
    startSimulation,
    resetSimulation,
  } = useSimulation();

  return (
    <div className="min-h-screen bg-slate-100 px-4 py-6">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4">
        <header>
          <h1 className="text-2xl font-semibold text-slate-900">EV Charging Simulation Demo</h1>
          <p className="text-sm text-slate-600">
            10 vehicles, 2 stations, 2 chargers/station, 5-minute resolution, 24-hour horizon.
          </p>
        </header>

        <ControlBar
          running={simulation.running}
          completed={simulation.completed}
          currentTimeLabel={currentTimeLabel}
          step={simulation.step}
          totalSteps={simulation.totalSteps}
          speedMultiplier={speedMultiplier}
          onStart={startSimulation}
          onReset={resetSimulation}
          onSpeedChange={setSpeedMultiplier}
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <StationPanel title="Station A" station={simulation.stations.stationA} vehicles={simulation.vehicles} />
          <StationPanel title="Station B" station={simulation.stations.stationB} vehicles={simulation.vehicles} />
        </div>

        <SimulationMap simulation={simulation} />

        <SimulationScene vehicles={simulation.vehicles} />

        <VehicleTable rows={vehicleRows} />

        <EventLog events={simulation.chargingEventLog} />

        {simulation.completed && <DemandCharts data={stationDemandData} />}
      </div>
    </div>
  );
}
